import instance from '@/utils/instance';

// 简版的标准信息
export function getBookDet(params) {
	return instance({
		url: `/webL_api/essential/api/book/${params}`,
		method: 'get'
	});
}

// 获取标准列表
export function getStandardBasicInfo(data) {
	return instance({
		url: `/webL_api/essential/api/getStandardBasicInfo?pageNum=${data.pageNum}&pageSize=${data.pageSize}`,
		method: 'post',
		data
	});
}

// 获取标准列表--全部商品---标题检索
export function getAllStandardBasicInfo(data) {
	return instance({
		url: `/webL_api/essential/api/getAllStandardBasicInfo?pageNum=${data.pageNum}&pageSize=${data.pageSize}`,
		method: 'post',
		data
	});
}

// 获取标准列表--只含标准---全文检索
export function getNormStandardBasicInfo(data) {
	return instance({
		url: `/webL_api/essential/api/getFullStandardBasicInfo?pageNum=${data.pageNum}&pageSize=${data.pageSize}`,
		method: 'post',
		data
	});
}

//标准明细信息
export function getStandardDet(params) {
	return instance({
		url: `/webL_api/essential/api/standardBasicInfo/${params}`,
		method: 'get'
	});
}

//获取标准列表-全文检索(特种设备)---全文检索
export function getNormStandardBasicInfoByFull(data) {
	return instance({
		url: `/webL_api/essential/api/getFullStandardBasicInfo?pageNum=${data.pageNum}&pageSize=${data.pageSize}`,
		method: 'post',
		data
	});
}


